import dayjs from 'dayjs';
import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import {
  Invoice,
  Company,
  Currency,
  OrderLine,
  OrderStatus,
  User,
  Vessel,
  Location,
  SubLocation,
} from './models';

export class Order extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'orders';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      invoice: this.hasOne(Invoice, 'order_id'),
      supplier_company_id: this.attr(null),
      supplier_company: this.belongsTo(Company, 'supplier_company_id'),
      supplier_contact_user_id: this.attr(null),
      supplier_contact_user: this.belongsTo(User, 'supplier_contact_user_id'),
      logistics_company_id: this.attr(null),
      logistics_company: this.belongsTo(Company, 'logistics_company_id'),
      logistics_contact_user_id: this.attr(null),
      logistics_contact_user: this.belongsTo(User, 'logistics_contact_user_id'),
      client_company_id: this.attr(null),
      client_company: this.belongsTo(Company, 'client_company_id'),
      client_contact_user_id: this.attr(null),
      client_contact_user: this.belongsTo(User, 'client_contact_user_id'),
      job_cargo_vessel: this.attr(null),
      vessel: this.belongsTo(Vessel, 'job_cargo_vessel'),
      job_lading_bill_issued_at: this.attr(null),
      job_additivation_started_at: this.attr(null),
      job_additivation_ended_at: this.attr(null),
      job_cargo_size_mtvac: this.attr(null),
      job_cargo_grade: this.attr(null),
      job_treatment_at: this.attr(null),
      job_location_id: this.attr(null),
      job_location: this.belongsTo(Location, 'job_location_id'),
      job_sub_location_id: this.attr(null),
      job_sub_location: this.belongsTo(SubLocation, 'job_sub_location_id'),
      is_historical: this.attr(0),
      type_code: this.attr(null),
      status_code: this.attr('pending'),
      status: this.belongsTo(OrderStatus, 'status_code', 'code'),
      currency_code: this.attr('EUR'),
      currency: this.belongsTo(Currency, 'currency_code', 'code'),
      number: this.attr(null),
      reference_no: this.attr(null),
      issued_at: this.attr(() => dayjs.utc().format('YYYY-MM-DD HH:mm:ss')),
      delivery_due_at: this.attr(null),
      loading_location_id: this.attr(null),
      loading_location: this.belongsTo(Location, 'loading_location_id'),
      loading_sub_location_id: this.attr(null),
      loading_sub_location: this.belongsTo(SubLocation, 'loading_sub_location_id'),
      notes: this.attr(null),
      order_lines: this.hasMany(OrderLine, 'order_id'),
      has_invoice: this.attr(null),
      has_invoice_sent: this.attr(null),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Order;
